export enum TemplateActionsUiEnum {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}
